export enum EversignDocumentType {
  FINANCING = 'financing',
  OFFER = 'offer',
  DISCLOSURE = 'disclosure',
  LISTING_AGREEMENT = 'listingAgreement'
}